export default "__VITE_ASSET__pOX1fjWL__"